import React from 'react'
import Banner from '../Containers/Banner/Banner'
import Search from '../Containers/Search'
import Footer from '../Containers/Footer'


const HomePage = () => {
  return (
    <div >
    <Banner />
    <Search />
    <Footer />
    </div>
  )
}

export default HomePage